<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-团队业绩-基础设置
      -->
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启团队业绩" prop="is_groupaward">
        <el-switch v-model="form.is_groupaward">
        </el-switch>
      </el-form-item>
      <el-form-item label="选择月度奖励发放等级" v-if="form.is_groupaward" v-auth="'/plus/groupaward/statement/index'">
        <el-select v-model="form.grade_id" multiple placeholder="请选择">
          <el-option
            v-for="item in gradeList"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
        <div class="gray9">选中的等级用户才能获得月度奖励</div>

      </el-form-item>
      <el-form-item label="月度团队业绩结算类型">
        <div>
          <el-radio-group  v-model="form.groupaward_type" @change="changeAwardType">
            <el-radio :label="0">按照销售金额</el-radio>
            <el-radio :label="1">按照销量</el-radio>
          </el-radio-group>
           <div class="tips red">销售金额以用户产品支付金额为准，销量按照总的产品销售量（试用于单品类）设置后请不要切换</div>
        </div>
      </el-form-item>
      <el-form-item label="月度团队业绩返利：" v-if="form.is_groupaward" v-auth="'/plus/groupaward/statement/index'">
        <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance">添加</el-button>
        <table border="0" cellpadding="2" cellspacing="5" class="mt30">
          <tr>
            <th class="tl">{{group_name}}</th>
            <th class="tl">{{group_value}}</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in form.performancedata" :key="index">
            <td><el-input size="small" v-model="item.performance" placeholder="请输入门槛参数"></el-input></td>
            <td><el-input size="small" v-model="item.awardRate" placeholder="请输入返利参数"></el-input></td>
            <td><el-button size="small" @click="delPerformance(index)">删除</el-button></td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item label="团队总业绩返利比例" v-if="form.is_groupaward" v-auth="'/plus/groupaward/team/index'">

          <el-input v-model="form.total_performance" placeholder="请输入团队总业绩的返利比例" type="number" style="width: 460px;">
            <template slot="append">%</template>
          </el-input>
          <div class="gray9">输入0-100之间</div>
      </el-form-item>
      <!--提交-->
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>
<script>
  import GroupAwardApi from '@/api/groupaward.js';
  export default {
    data() {
      return {
        form: {
          is_groupaward: false,
          performancedata: [],
          grade_id:[],
          total_performance:0,
          groupaward_type:0,
        },
        gradeList:[],
        loading: false,
        group_name:'销售业绩(元)',
        group_value:'返佣比例(%)',

      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      /*换算单位*/
      changeAwardType: function(val) {
         let self = this;
          if (val == 0) {
            this.group_name = '销售业绩(元)';
            this.group_value = '返佣比例(%)';
          } else {
            this.group_name = '销量（件）';
            this.group_value = '返佣参数(元/件)';
          }
      },
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        GroupAwardApi.getSetting(Params, true)
          .then(data => {
            self.form = data.data.vars.values;
            if(!self.form.grade_id){
              self.$set(self.form,'grade_id',[]);
            }
            self.changeAwardType(self.form.groupaward_type)
            self.gradeList = data.data.gradeList;
            self.loading = false;
          })
          .catch(error => {});
      },
      AddPerformance(){
        let self = this;
        let data = {'performance':0,'awardRate':0};
        self.form.performancedata.push(data);
      },
      delPerformance(key){
        let self = this;
        let performancedata = self.form.performancedata;
        let newdata = [];
        performancedata.forEach((item,index)=>{
          if(index != key){
            newdata.push(item);
          }
        });
        self.form.performancedata = newdata;
      },
      /*点击保存*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.loading = true;
        if(params.total_performance <0 || params.total_performance >100){
          self.$message({
            message: '请输入0-100之间',
            type: 'error'
          });
          self.loading = false;
          return false;
        }
        GroupAwardApi.saveSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/groupaward/setting/getSetting.vue